export const GET_USER_BUSINESS_AREA_BY_NAME_REQUEST = "GET_USER_BUSINESS_AREA_BY_NAME_REQUEST";
export const GET_USER_BUSINESS_AREA_BY_NAME_SUCCESS = "GET_USER_BUSINESS_AREA_BY_NAME_SUCCESS";
export const GET_USER_BUSINESS_AREA_BY_NAME_FAILURE = "GET_USER_BUSINESS_AREA_BY_NAME_FAILURE";

export const GET_SCHEMA_MODELS_REQUEST = "GET_SCHEMA_MODELS_REQUEST";
export const GET_SCHEMA_MODELS_SUCCESS = "GET_SCHEMA_MODELS_SUCCESS";
export const GET_SCHEMA_MODELS_FAILURE = "GET_SCHEMA_MODELS_FAILURE";

export const GET_RECENT_SCHEMA_MODELS_REQUEST = "GET_RECENT_SCHEMA_MODELS_REQUEST";
export const GET_RECENT_SCHEMA_MODELS_SUCCESS = "GET_RECENT_SCHEMA_MODELS_SUCCESS";
export const GET_RECENT_SCHEMA_MODELS_FAILURE = "GET_RECENT_SCHEMA_MODELS_FAILURE";

export const GET_SCHEMA_MODELS_NEXT_PAGE_REQUEST = "GET_SCHEMA_MODELS_NEXT_PAGE_REQUEST";
export const GET_SCHEMA_MODELS_NEXT_PAGE_SUCCESS = "GET_SCHEMA_MODELS_NEXT_PAGE_SUCCESS";
export const GET_SCHEMA_MODELS_NEXT_PAGE_FAILURE = "GET_SCHEMA_MODELS_NEXT_PAGE_FAILURE";

export const CREATE_SCHEMA_MODEL_REQUEST = "CREATE_SCHEMA_MODEL_REQUEST";
export const CREATE_SCHEMA_MODEL_SUCCESS = "CREATE_SCHEMA_MODEL_SUCCESS";
export const CREATE_SCHEMA_MODEL_FAILURE = "CREATE_SCHEMA_MODEL_FAILURE";

export const DELETE_SCHEMA_MODEL_REQUEST = "DELETE_SCHEMA_MODEL_REQUEST";
export const DELETE_SCHEMA_MODEL_SUCCESS = "DELETE_SCHEMA_MODEL_SUCCESS";
export const DELETE_SCHEMA_MODEL_FAILURE = "DELETE_SCHEMA_MODEL_FAILURE";

export const GET_SCHEMA_MODEL_REQUEST = "GET_SCHEMA_MODEL_REQUEST";
export const GET_SCHEMA_MODEL_SUCCESS = "GET_SCHEMA_MODEL_SUCCESS";
export const GET_SCHEMA_MODEL_FAILURE = "GET_SCHEMA_MODEL_FAILURE";

export const GET_SCHEMA_MODEL_BY_NAME_REQUEST = "GET_SCHEMA_MODEL_BY_NAME_REQUEST";
export const GET_SCHEMA_MODEL_BY_NAME_SUCCESS = "GET_SCHEMA_MODEL_BY_NAME_SUCCESS";
export const GET_SCHEMA_MODEL_BY_NAME_FAILURE = "GET_SCHEMA_MODEL_BY_NAME_FAILURE";

export const UPDATE_SCHEMA_MODEL_REQUEST = "UPDATE_SCHEMA_MODEL_REQUEST";
export const UPDATE_SCHEMA_MODEL_SUCCESS = "UPDATE_SCHEMA_MODEL_SUCCESS";
export const UPDATE_SCHEMA_MODEL_FAILURE = "UPDATE_SCHEMA_MODEL_FAILURE";

export const GET_USER_SCHEMA_MODELS_PERMISSION_REQUEST = "GET_USER_SCHEMA_MODELS_PERMISSION_REQUEST";
export const GET_USER_SCHEMA_MODELS_PERMISSION_SUCCESS = "GET_USER_SCHEMA_MODELS_PERMISSION_SUCCESS";
export const GET_USER_SCHEMA_MODELS_PERMISSION_FAILURE = "GET_USER_SCHEMA_MODELS_PERMISSION_FAILURE";

export const GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_REQUEST = "GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_REQUEST";
export const GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_SUCCESS = "GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_SUCCESS";
export const GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_FAILURE = "GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_FAILURE";

export const UPLOAD_SCHEMA_MODEL_DEFINITION_REQUEST = "UPLOAD_SCHEMA_MODEL_DEFINITION_REQUEST";
export const UPLOAD_SCHEMA_MODEL_DEFINITION_SUCCESS = "UPLOAD_SCHEMA_MODEL_DEFINITION_SUCCESS";
export const UPLOAD_SCHEMA_MODEL_DEFINITION_FAILURE = "UPLOAD_SCHEMA_MODEL_DEFINITION_FAILURE";

export const getUserBusinessAreaByNameRequest = (businessAreaName) => ({
    type: GET_USER_BUSINESS_AREA_BY_NAME_REQUEST,
    params: {
        businessAreaName,
    },
});

// requestedName: the name (or id) the business area was asked for by.
export const getUserBusinessAreaByNameSuccess = (userBusinessArea, requestedName) => ({
    type: GET_USER_BUSINESS_AREA_BY_NAME_SUCCESS,
    payload: userBusinessArea,
    requestedName,
});

export const getUserBusinessAreaByNameFailure = (error) => ({
    type: GET_USER_BUSINESS_AREA_BY_NAME_FAILURE,
    payload: error,
});

export const getSchemaModelsRequest = (businessAreaId) => ({
    type: GET_SCHEMA_MODELS_REQUEST,
    params: {
        businessAreaId,
    },
});

export const getSchemaModelsSuccess = (schemaModels) => ({
    type: GET_SCHEMA_MODELS_SUCCESS,
    payload: schemaModels,
});

export const getSchemaModelsFailure = (error) => ({
    type: GET_SCHEMA_MODELS_FAILURE,
    payload: error,
});

export const getRecentSchemaModelsRequest = () => ({
    type: GET_RECENT_SCHEMA_MODELS_REQUEST,
});

export const getRecentSchemaModelsSuccess = (schemaModelsResult) => ({
    type: GET_RECENT_SCHEMA_MODELS_SUCCESS,
    payload: schemaModelsResult,
});

export const getRecentSchemaModelsFailure = (error) => ({
    type: GET_RECENT_SCHEMA_MODELS_FAILURE,
    payload: {
        error,
    },
});

export const getSchemaModelsNextPageRequest = (businessAreaId, pageKey) => ({
    type: GET_SCHEMA_MODELS_NEXT_PAGE_REQUEST,
    params: {
        businessAreaId,
        pageKey,
    },
});

export const getSchemaModelsNextPageSuccess = (schemaModels) => ({
    type: GET_SCHEMA_MODELS_NEXT_PAGE_SUCCESS,
    payload: schemaModels,
});

export const getSchemaModelsNextPageFailure = (error) => ({
    type: GET_SCHEMA_MODELS_NEXT_PAGE_FAILURE,
    payload: error,
});

export const createSchemModelRequest = (businessAreaId, schemaModel) => ({
    type: CREATE_SCHEMA_MODEL_REQUEST,
    params: {
        businessAreaId,
        schemaModel,
    },
});

export const createSchemModelSuccess = ({ schemaModel }) => ({
    type: CREATE_SCHEMA_MODEL_SUCCESS,
    payload: {
        schemaModel,
    },
});

export const createSchemModelFailure = (error) => ({
    type: CREATE_SCHEMA_MODEL_FAILURE,
    payload: error,
});

export const deleteSchemaModelRequest = (businessAreaId, schemaId) => ({
    type: DELETE_SCHEMA_MODEL_REQUEST,
    params: {
        businessAreaId,
        schemaId,
    },
});

export const deleteSchemaModelSuccess = (businessAreaId, schemaId) => ({
    type: DELETE_SCHEMA_MODEL_SUCCESS,
    payload: {
        businessAreaId,
        schemaId,
    },
});

export const deleteSchemaModelFailure = (error) => ({
    type: DELETE_SCHEMA_MODEL_FAILURE,
    payload: error,
});

export const getSchemaModelRequest = (businessAreaId, schemaId) => ({
    type: GET_SCHEMA_MODEL_REQUEST,
    params: {
        businessAreaId,
        schemaId,
    },
});

export const getSchemaModelSuccess = (schemaModel) => ({
    type: GET_SCHEMA_MODEL_SUCCESS,
    payload: schemaModel,
});

export const getSchemaModelFailure = (error) => ({
    type: GET_SCHEMA_MODEL_FAILURE,
    payload: error,
});

export const getSchemaModelByNameRequest = (businessAreaId, schemaName) => ({
    type: GET_SCHEMA_MODEL_BY_NAME_REQUEST,
    params: {
        businessAreaId,
        schemaName,
    },
});

export const getSchemaModelByNameSuccess = (schemaModel) => ({
    type: GET_SCHEMA_MODEL_BY_NAME_SUCCESS,
    payload: {
        schemaModel,
    },
});

export const getSchemaModelByNameFailure = (error) => ({
    type: GET_SCHEMA_MODEL_BY_NAME_FAILURE,
    payload: error,
});

export const updateSchemaModelRequest = (businessAreaId, schemaId, updateSchemaModelData, fieldIndexMappings, source) => ({
    type: UPDATE_SCHEMA_MODEL_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        updateSchemaModelData,
        fieldIndexMappings,
        source,
    },
});

export const updateSchemaModelSuccess = (source) => ({
    type: UPDATE_SCHEMA_MODEL_SUCCESS,
    payload: { source },
});

export const updateSchemaModelFailure = (error) => ({
    type: UPDATE_SCHEMA_MODEL_FAILURE,
    payload: error,
});

export const getUserSchemaModelsPermissionRequest = () => ({
    type: GET_USER_SCHEMA_MODELS_PERMISSION_REQUEST,
});

export const getUserSchemaModelsPermissionSuccess = (permission) => ({
    type: GET_USER_SCHEMA_MODELS_PERMISSION_SUCCESS,
    payload: permission,
});

export const getUserSchemaModelsPermissionFailure = (error) => ({
    type: GET_USER_SCHEMA_MODELS_PERMISSION_FAILURE,
    payload: error,
});

export const getBusinessAreaDataForBusinessAreaRequest = (businessAreaId) => ({
    type: GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_REQUEST,
    params: {
        businessAreaId,
    },
});

export const getBusinessAreaDataForBusinessAreaSuccess = (businessAreaDataList) => ({
    type: GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_SUCCESS,
    payload: businessAreaDataList,
});

export const getBusinessAreaDataForBusinessAreaFailure = (error) => ({
    type: GET_BUSINESS_AREA_DATA_FOR_BUSINESS_AREA_FAILURE,
    payload: error,
});

export const uploadSchemaModelDefinitionRequest = (businessAreaId, dataFile) => ({
    type: UPLOAD_SCHEMA_MODEL_DEFINITION_REQUEST,
    params: {
        businessAreaId,
        dataFile,
    },
});

export const uploadSchemaModelDefinitionSuccess = ({ bucket, key, region }) => ({
    type: UPLOAD_SCHEMA_MODEL_DEFINITION_SUCCESS,
    payload: {
        bucket,
        key,
        region,
    },
});

export const uploadSchemaModelDefinitionFailure = (error) => ({
    type: UPLOAD_SCHEMA_MODEL_DEFINITION_FAILURE,
    payload: {
        error,
    },
});

export const SAVE_MAPPING_CONFIGURATION_REQUEST = "SAVE_MAPPING_CONFIGURATION_REQUEST";
export const SAVE_MAPPING_CONFIGURATION_SUCCESS = "SAVE_MAPPING_CONFIGURATION_SUCCESS";
export const SAVE_MAPPING_CONFIGURATION_FAILURE = "SAVE_MAPPING_CONFIGURATION_FAILURE";

export const GET_MAPPING_CONFIGURATIONS_REQUEST = "GET_MAPPING_CONFIGURATIONS_REQUEST";
export const GET_MAPPING_CONFIGURATIONS_SUCCESS = "GET_MAPPING_CONFIGURATIONS_SUCCESS";
export const GET_MAPPING_CONFIGURATIONS_FAILURE = "GET_MAPPING_CONFIGURATIONS_FAILURE";

export const DELETE_MAPPING_CONFIGURATION_REQUEST = "DELETE_MAPPING_CONFIGURATION_REQUEST";
export const DELETE_MAPPING_CONFIGURATION_SUCCESS = "DELETE_MAPPING_CONFIGURATION_SUCCESS";
export const DELETE_MAPPING_CONFIGURATION_FAILURE = "DELETE_MAPPING_CONFIGURATION_FAILURE";

export const saveMappingConfigurationRequest = (businessAreaId, schemaId, title, mappingConfiguration) => ({
    type: SAVE_MAPPING_CONFIGURATION_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        title,
        mappingConfiguration,
    },
});

export const saveMappingConfigurationSuccess = (mappingConfigurations) => ({
    type: SAVE_MAPPING_CONFIGURATION_SUCCESS,
    payload: mappingConfigurations,
});

export const saveMappingConfigurationFailure = (error) => ({
    type: SAVE_MAPPING_CONFIGURATION_FAILURE,
    payload: error,
});

export const getMappingConfigurationsRequest = (businessAreaId, schemaId) => ({
    type: GET_MAPPING_CONFIGURATIONS_REQUEST,
    params: {
        businessAreaId,
        schemaId,
    },
});

export const getMappingConfigurationsSuccess = (mappingConfigurations) => ({
    type: GET_MAPPING_CONFIGURATIONS_SUCCESS,
    payload: mappingConfigurations,
});

export const getMappingConfigurationsFailure = (error) => ({
    type: GET_MAPPING_CONFIGURATIONS_FAILURE,
    payload: error,
});

export const deleteMappingConfigurationRequest = (businessAreaId, schemaId, configurationId) => ({
    type: DELETE_MAPPING_CONFIGURATION_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        configurationId,
    },
});

export const deleteMappingConfigurationSuccess = (mappingConfigurations) => ({
    type: DELETE_MAPPING_CONFIGURATION_SUCCESS,
    payload: mappingConfigurations,
});

export const deleteMappingConfigurationFailure = (error) => ({
    type: DELETE_MAPPING_CONFIGURATION_FAILURE,
    payload: error,
});

export const GENERATE_SCHEMA_HEALTH_REPORT_REQUEST = "GENERATE_SCHEMA_HEALTH_REPORT_REQUEST";
export const GENERATE_SCHEMA_HEALTH_REPORT_SUCCESS = "GENERATE_SCHEMA_HEALTH_REPORT_SUCCESS";
export const GENERATE_SCHEMA_HEALTH_REPORT_FAILURE = "GENERATE_SCHEMA_HEALTH_REPORT_FAILURE";

export const generateSchemaHealthReportRequest = (schemaId, businessAreaId, regenerate) => ({
    type: GENERATE_SCHEMA_HEALTH_REPORT_REQUEST,
    params: {
        schemaId,
        businessAreaId,
        regenerate,
    },
});

export const generateSchemaHealthReportSuccess = (reportHtml) => ({
    type: GENERATE_SCHEMA_HEALTH_REPORT_SUCCESS,
    payload: {
        reportHtml,
    },
});

export const generateSchemaHealthReportFailure = (error) => ({
    type: GENERATE_SCHEMA_HEALTH_REPORT_FAILURE,
    payload: {
        error,
    },
});

export const GET_PII_SUGGESTIONS_REQUEST = "GET_PII_SUGGESTIONS_REQUEST";
export const GET_PII_SUGGESTIONS_SUCCESS = "GET_PII_SUGGESTIONS_SUCCESS";
export const GET_PII_SUGGESTIONS_FAILURE = "GET_PII_SUGGESTIONS_FAILURE";

export const SAVE_PII_SUGGESTIONS_REQUEST = "SAVE_PII_SUGGESTIONS_REQUEST";
export const SAVE_PII_SUGGESTIONS_SUCCESS = "SAVE_PII_SUGGESTIONS_SUCCESS";
export const SAVE_PII_SUGGESTIONS_FAILURE = "SAVE_PII_SUGGESTIONS_FAILURE";

export const CLEAR_PII_SUGGESTIONS = "CLEAR_PII_SUGGESTIONS";

export const getPiiSuggestionsRequest = (schemaId, businessAreaId) => ({
    type: GET_PII_SUGGESTIONS_REQUEST,
    params: {
        schemaId,
        businessAreaId,
    },
});

export const getPiiSuggestionsSuccess = (data) => ({
    type: GET_PII_SUGGESTIONS_SUCCESS,
    payload: data,
});

export const getPiiSuggestionsFailure = (error) => ({
    type: GET_PII_SUGGESTIONS_FAILURE,
    payload: error,
});

export const savePiiSuggestionsRequest = (businessAreaId, schemaId, updatedFields) => ({
    type: SAVE_PII_SUGGESTIONS_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        updatedFields,
    },
});

export const savePiiSuggestionsSuccess = () => ({
    type: SAVE_PII_SUGGESTIONS_SUCCESS,
});

export const savePiiSuggestionsFailure = (error) => ({
    type: SAVE_PII_SUGGESTIONS_FAILURE,
    payload: error,
});

export const clearPiiSuggestions = () => ({
    type: CLEAR_PII_SUGGESTIONS,
});

export const GET_FIELD_DESCRIPTIONS_REQUEST = "GET_FIELD_DESCRIPTIONS_REQUEST";
export const GET_FIELD_DESCRIPTIONS_SUCCESS = "GET_FIELD_DESCRIPTIONS_SUCCESS";
export const GET_FIELD_DESCRIPTIONS_FAILURE = "GET_FIELD_DESCRIPTIONS_FAILURE";

export const SAVE_FIELD_DESCRIPTIONS_REQUEST = "SAVE_FIELD_DESCRIPTIONS_REQUEST";
export const SAVE_FIELD_DESCRIPTIONS_SUCCESS = "SAVE_FIELD_DESCRIPTIONS_SUCCESS";
export const SAVE_FIELD_DESCRIPTIONS_FAILURE = "SAVE_FIELD_DESCRIPTIONS_FAILURE";

export const CLEAR_FIELD_DESCRIPTIONS = "CLEAR_FIELD_DESCRIPTIONS";

export const getFieldDescriptionsRequest = (schemaId, businessAreaId) => ({
    type: GET_FIELD_DESCRIPTIONS_REQUEST,
    params: {
        schemaId,
        businessAreaId,
    },
});

export const getFieldDescriptionsSuccess = (data) => ({
    type: GET_FIELD_DESCRIPTIONS_SUCCESS,
    payload: data,
});

export const getFieldDescriptionsFailure = (error) => ({
    type: GET_FIELD_DESCRIPTIONS_FAILURE,
    payload: error,
});

export const saveFieldDescriptionsRequest = (businessAreaId, schemaId, updatedFields, schemaDescription) => ({
    type: SAVE_FIELD_DESCRIPTIONS_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        updatedFields,
        schemaDescription,
    },
});

export const saveFieldDescriptionsSuccess = () => ({
    type: SAVE_FIELD_DESCRIPTIONS_SUCCESS,
});

export const saveFieldDescriptionsFailure = (error) => ({
    type: SAVE_FIELD_DESCRIPTIONS_FAILURE,
    payload: error,
});

export const clearFieldDescriptions = () => ({
    type: CLEAR_FIELD_DESCRIPTIONS,
});

export const GENERATE_DDL_SQL_REQUEST = "GENERATE_DDL_SQL_REQUEST";
export const GENERATE_DDL_SQL_SUCCESS = "GENERATE_DDL_SQL_SUCCESS";
export const GENERATE_DDL_SQL_FAILURE = "GENERATE_DDL_SQL_FAILURE";

export const CLEAR_DDL_SQL = "CLEAR_DDL_SQL";

export const generateDdlSqlRequest = (schemaId, businessAreaId) => ({
    type: GENERATE_DDL_SQL_REQUEST,
    params: {
        schemaId,
        businessAreaId,
    },
});

export const generateDdlSqlSuccess = (data) => ({
    type: GENERATE_DDL_SQL_SUCCESS,
    payload: data,
});

export const generateDdlSqlFailure = (error) => ({
    type: GENERATE_DDL_SQL_FAILURE,
    payload: error,
});

export const clearDdlSql = () => ({
    type: CLEAR_DDL_SQL,
});

export const GENERATE_GAP_PREDICTION_REQUEST = "GENERATE_GAP_PREDICTION_REQUEST";
export const GENERATE_GAP_PREDICTION_SUCCESS = "GENERATE_GAP_PREDICTION_SUCCESS";
export const GENERATE_GAP_PREDICTION_FAILURE = "GENERATE_GAP_PREDICTION_FAILURE";

export const CLEAR_GAP_PREDICTION = "CLEAR_GAP_PREDICTION";

export const generateGapPredictionRequest = (schemaId, businessAreaId, regenerate = false) => ({
    type: GENERATE_GAP_PREDICTION_REQUEST,
    params: {
        schemaId,
        businessAreaId,
        regenerate,
    },
});

export const generateGapPredictionSuccess = (data) => ({
    type: GENERATE_GAP_PREDICTION_SUCCESS,
    payload: data,
});

export const generateGapPredictionFailure = (error) => ({
    type: GENERATE_GAP_PREDICTION_FAILURE,
    payload: error,
});

export const clearGapPrediction = () => ({
    type: CLEAR_GAP_PREDICTION,
});
